import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-add-existing-doc-arc',
  templateUrl: './add-existing-doc-arc.component.html',
  styleUrls: ['./add-existing-doc-arc.component.css']
})
export class AddExistingDocArcComponent implements OnChanges {
    @Input()
    public params?: { argtype: string; argvalue: string; };

    public setting?: Setting;

    public grid?: GridOptions;

    public docArcSearchTextButtons: FormButton[] = [{
        id: 'search', icon: 'fas fa-search', type: 'primary', onClick: () => this.loadGrid()
    }];

    constructor(private datatask: DataTaskService) {

    }

    public submitSearch() {
        this.loadGrid();
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'docarc_searchtext':
                if (this.setting?.docarc_searchtext === '') this.loadGrid();
                break;
            default:
                break;
        }
    }

    private loadGrid() {
        this.grid?.gridfunc?.read();
    }

    private createGrid() {
        this.grid = new Grid().setRememberId('w_addexistingdocarc_grid').setLoadDataFunction({ method: 3757, parameters: () => this.setting }).setKendoConfig({ height: '100%' });
    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3756, this.params))[0];
    }

    private async init() {
        await this.loadSetting();
        this.createGrid();
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log(changes);
        if (changes['params'] && changes['params'].currentValue) {
            this.init();
        }
    }
}

interface Setting {
    page_heading: string;
    docarc_searchtext: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('addExistingDocArc', {
//        templateUrl: 'views/components/views/addExistingDocArc/addExistingDocArc.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'addExistingDocArcService', 'ttGridFactory', function ($stateParams, utilityService, addExistingDocArcService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                gridReady: false,
//                docArcSearchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('docarc_searchtext') },
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => loadGrid() }
//                ],
//                setting: {}
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_addexistingdocarc_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await addExistingDocArcService.getSetting({
//                    argtype: argType,
//                    argvalue: argValue,
//                }))[0];

//                return loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3757,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region MULTI CLEAR FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'docarc_searchtext':
//                        vm.model.setting.docarc_searchtext = '';

//                        if (vm.model.setting.docarc_searchtext === '') loadGrid();
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI CLEAR FUNCTION

//            // #region SUBMIT SEARCH FUNCTION

//            vm.submitSearch = function () {
//                loadGrid();
//            }

//            // #endregion SUBMIT SEARCH FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'docarc_searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.docarc_searchtext) !== true) return;

//                        vm.model.setting.docarc_searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.docarc_searchtext, true) !== true) return;

//                        if (vm.model.setting.docarc_searchtext === '') loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
